"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const uk_1 = __importDefault(require("date-fns/locale/uk")); //
const dateUkUA = {
    name: 'uk-UA',
    locale: uk_1.default
};
exports.default = dateUkUA;
